import { createContext } from "react"

const notificationsContext = createContext({
  notify_quotations: [],
  notify_sale_orders: [],
  notify_receipts: [],
  notify_receipt_payments: [],
  notify_receipt_cancels: [],
  sendNotifications: () => { },
  fetchNotifications: () => { },
})

export const NotificationsProvider = notificationsContext.Provider
export const NotificationsConsumer = notificationsContext.Consumer